export const getLastUpdate = () => {
  const data = new Date()
  return data.toISOString()
}
